angular.module('CarsSaraBo').controller('ImpersonateController', ['$scope', '$rootScope', 'CompanyServicePage', '$http', '$filter', 'GeoService', 'LoadingWheelService',
    function ($scope, $rootScope, companyServicePage, $http, $filter, geoService, loadingWheelService) {

        function initialize() {
            loadingWheelService.show();
            $scope.cleanCompanyToRepresent();

            $scope.companies = [];
            $scope.inputFilter = {};
            $scope.inputFilter.period = {};
            $scope.filter = {};
            $scope.order = {field: "COMPANY_ID", dir: "asc"};
            $scope.showNotResultsFountMessage = false;

            $scope.filter.sortingColumnName = $scope.order.field;
            $scope.filter.sSortDir_0 = $scope.order.dir;
            $scope.maxDate = calculateMaxDate();
            $scope.search();
        }

        function calculateMaxDate() {
            var date = new Date();
            let dateWithYears = new Date(date.setFullYear(new Date().getFullYear() + 2));
            return formatDate(dateWithYears);
        }

        function formatDate(inputFormat) {
            function pad(s) { return (s < 10) ? '0' + s : s; }
            var d = new Date(inputFormat);
            return [d.getFullYear(), pad(d.getMonth()+1), pad(d.getDate())].join('-');
        }

        $scope.getLoading = function () {
            return loadingWheelService.isLoading();
        }

        $scope.impersonate = function (company) {
            $scope.setCompanyToRepresent(company);
            $rootScope.sidebarVisible = true;
            $scope.goToDefaultTargetUrl(company.oid);
        }

        $scope.locationLike = function (like) {
            return geoService.getAirportsAndCities(like, $rootScope.lang.name).then(function (response) {
                return response.data
            });
        };

        $scope.companyNameLike = function (like) {
            var requestConfig = {
                params: {
                    nameLike: like
                }
            };
            return $http.get("../rest/company/search", requestConfig).then(function (response) {
                return response.data
            });
        }

        function isDefined(value) {
            return (value != null && value != undefined && value != '');
        }

        $scope.search = function (pageNumber) {

            if (isDefined($scope.inputFilter.companyLocation)) {
                $scope.filter.companyCity = $scope.inputFilter.companyLocation.locationOid;
            } else {
                $scope.filter.companyCity = undefined;
            }

            //Esta validacion es porque la busqueda por nombre termina siendo una busqueda por oid,
            //pero como tambien se puede ingresar un oid para buscar, este ultimo tiene prioridad.
            if (isDefined($scope.inputFilter.companyOid)) {
                $scope.filter.companyOID = $scope.inputFilter.companyOid;
            } else {
                if (isDefined($scope.inputFilter.companyName)) {
                    $scope.filter.companyOID = $scope.inputFilter.companyName.oid;
                } else {
                    $scope.filter.companyOID = undefined;
                }
            }


            if (isDefined($scope.inputFilter.period.creationFrom)) {
                var date = $scope.inputFilter.period.creationFrom;
                $scope.filter["period.from"] = $filter('date')(date.getTime(), "yyyyMMdd");
            } else {
                $scope.filter["period.from"] = null;
            }

            if (isDefined($scope.inputFilter.period.creationTo)) {
                var date = $scope.inputFilter.period.creationTo;
                $scope.filter["period.to"] = $filter('date')(date.getTime(), "yyyyMMdd");
            } else {
                $scope.filter["period.to"] = null;
            }

            loadingWheelService.show();
            $scope.filter.pageNumber = pageNumber;

            companyServicePage.queryPage($scope.filter, function (page) {
                $scope.companies = page.items;
                $scope.totalItems = page.totalItems;
                $scope.itemsPerPage = page.itemsPerPage;
                $scope.currentPage = page.currentPage;
                loadingWheelService.hide();
                $scope.showNotResultsFountMessage = (page.totalItems == 0);
            });

        }


        function searchPoint(poins, point, isPointOfSale) {
            for (var j = 0; j < poins.length; j++) {
                var current = poins[j];
                if (current.locationOid == point.locationOid &&
                    current.isPointOfSale == isPointOfSale) {
                    return j;
                }
            }
            return -1;
        }

        function addPointToArray(pointsToShow, index, point, isPointOfSale) {

            pointsToShow[pointsToShow.length] = {
                locationOid: point.locationOid,
                locationName: point.locationName,
                isPointOfSale: isPointOfSale
            };

        }

        $scope.renderPointsTitle = function (pointsToShow) {
            var title = "";
            for (var f = 0; f < pointsToShow.length; f++) {
                var pointAux = pointsToShow[f];
                title += (pointAux.isPointOfSale ? "• " : "• (*) ") + pointAux.locationName + "\n";
            }

            return title;
        }

        $scope.removeRepeatedPoints = function (pointOfSales) {

            var pointsToShow = [];

            for (var i = 0; i < pointOfSales.length; i++) {
                var point = pointOfSales[i];
                var index = searchPoint(pointsToShow, point, true);
                if (index == -1) {
                    addPointToArray(pointsToShow, index, point, true);
                }
                for (var l = 0; l < point.pickupPoints.length; l++) {
                    var pPoint = point.pickupPoints[l];
                    index = searchPoint(pointsToShow, pPoint, false);
                    if (index == -1) {
                        addPointToArray(pointsToShow, index, pPoint, false);
                    }
                }

            }

            return pointsToShow;
        }

        $scope.goToFirstPage = function () {
            $scope.currentPage = 1;
            $scope.changePage();
        }

        $scope.changePage = function () {
            $scope.search($scope.currentPage);
        }

        $scope.sort = function (fieldName, dir) {

            if ($scope.order.field != fieldName) {
                $scope.order.field = fieldName;
                $scope.order.dir = dir != undefined ? dir : "asc";
            } else {
                $scope.order.dir = dir != undefined ? dir : ($scope.order.dir == "asc" ? "desc" : "asc");
            }

            $scope.filter.sortingColumnName = $scope.order.field;
            $scope.filter.sSortDir_0 = $scope.order.dir;

            $scope.goToFirstPage();
        }

        $scope.getPointOfSaleToShow = function (pointOfSales) {
            //Si se filtro por ciudad, muestra el punto de venta o pickup que corresponde.
            if ($scope.filter.companyCity != undefined) {
                for (var i = 0; i < pointOfSales.length; i++) {
                    var p = pointOfSales[i];
                    if (p.locationOid == $scope.filter.companyCity) {
                        return p.locationName;
                    }
                    for (var j = 0; j < p.pickupPoints.length; j++) {
                        var pp = p.pickupPoints[j];
                        if (pp.locationOid == $scope.filter.companyCity) {
                            return pp.locationName;
                        }
                    }
                }
            } else {
                return pointOfSales.length > 0 ? pointOfSales[0].locationName : "";
            }

        };

        $scope.removeNonNumbers = function () {
            var buffer = "";

            for (var c in $scope.inputFilter.companyOid) {

                if (!isNaN(parseInt($scope.inputFilter.companyOid.toString()[c]))) {
                    buffer += $scope.inputFilter.companyOid.toString()[c];
                }
            }

            $scope.inputFilter.companyOid = buffer;
        };

        geoService.getCountries().success(function (response) {
            $scope.countries = response;
        });

        initialize();
    }]);


//////////////////
// WEBPACK FOOTER
// ./public/app/controllers/impersonate_controller.js
// module id = 902
// module chunks = 3